module.exports = __webpack_public_path__ + "img/1547805474.9b18148c.jpg";